import singlePageProps from '../../lib/singlePageProps';
import { investorQuery } from '../../lib/queries';
import { getClient, overlayDrafts } from '../../lib/sanity.server';
import {
  BigQuote,
  BottomCTA,
  Customizable,
  EasyToUse,
  Features,
  PartnersLogoCloud,
  TopCTA
} from '@components/startups';
import { Investors } from '@components';
import { CShapeBlurPattern } from '@components';
import { useMediaQuery } from '@chakra-ui/react';

const applyURL = 'https://2y2mhpgqtw5.typeform.com/to/uKXUVeca';

export default function StartupsPage({ investors }: any) {
  const [isLargerThan800] = useMediaQuery('(min-width: 800px)');

  return (
    <main>
      <section className="px-6 mx-auto mt-36 max-w-7xl">
        <TopCTA applyURL={applyURL} />
      </section>
      <section className="py-8 mt-20">
        <BigQuote
          quote="It’s great to see a service focus on taking away all the pain related to user management—not just login."
          name="Guillermo Rauch"
          titles={['CEO, Vercel']}
          imageURL="/avatars/guillermo.jpeg"
        />
        <BigQuote
          quote="Working on account.php at Facebook was like being in a landmine field, and I love that Clerk’s User Profile solves that."
          name="Aditya Agrawal"
          titles={['Early employee, Facebook', 'Ex-CTO, Dropbox']}
          imageURL="/avatars/aditya.png"
        />
      </section>
      {/* {isLargerThan800 && (
        <>
          <CShapeBlurPattern top={'0vh'} left={'55vw'} rotate={300} />
          <CShapeBlurPattern top={'50vh'} right={'55vw'} />
          <CShapeBlurPattern top={'85vh'} left={'55vw'} rotate={200} />
          <CShapeBlurPattern top={'105vh'} left={'55vw'} rotate={200} />
          <CShapeBlurPattern top={'200vh'} left={'55vw'} rotate={200} />
          <CShapeBlurPattern top={'210vh'} right={'55vw'} rotate={200} />
        </>
      )} */}
      <PartnersLogoCloud />
      <Features />
      <Customizable imagePosition="left" />
      <EasyToUse imagePosition="right" />
      <Investors investors={investors} />
      <BottomCTA applyURL={applyURL} />
    </main>
  );
}

const slug = '/startups';
export async function getStaticProps({ preview = false }) {
  const page = await singlePageProps({ preview, slug });
  const investors = overlayDrafts(
    await getClient(preview).fetch(investorQuery)
  );

  return {
    props: { investors, ...page.props }
  };
}
